import React, { useEffect, useState } from "react";
import CustomButton from "../../../components/Form/ArrowButton";

import PayPal from "../../../assets/Icons/Paypal.svg";
import ProgressBar from "../../../components/Form/ProgressBar";
import { useNavigate, useParams } from "react-router-dom";
import { fetchUserOrderById } from "../../../store";
import { useThunk } from "../../../hooks/useThunk";
import showToast from "../../../utils/toastNotifications";
import { currencyFormatter } from "../../../utils/formatting";
import { formatYYYY_MM_DD } from "../../../utils/dateFormating";
import { ClipLoader } from "react-spinners";

const SuccessPayment = () => {

  const navigate = useNavigate();
  const params = useParams();

  // Progressbar functions
  const steps = [
    { fullLabel: "Calculation", shortLabel: "Calculation" },
    { fullLabel: "Paper Instructions", shortLabel: "Instructions" },
    { fullLabel: "Secure Payment", shortLabel: "Payment" },
  ];

  const [currentOrder, setCurrentOrder] = useState(null);

  // defining custom hooks
  const [doFetchUserOrderById, isFetchUserOrderById, fetchUserOrderByIdError] = useThunk(fetchUserOrderById);

  // fetch the order details from the path variable or navigates to the calculation age if the order id not found 
  useEffect(() => {
    if (!params['*'] || params['*']?.toString()?.length < 1) {
      navigate("/calculation");
    } else {
      fetchOrdersByIdMethod();
    }
  }, []);
  
  // navigates to the threads: to specifi order/thread
  const handleProceed = () => {
    navigate(`/thread?roomIdParam=${currentOrder?.id}&threadIdParam=${currentOrder?.threadId}`);
  };

  // fetch order by it;s id
  const fetchOrdersByIdMethod = async (param) => {
    const result = await doFetchUserOrderById({ id: params['*'] });
    if (result?.success) {
      setCurrentOrder(result?.response?.data);
      showToast("success", "Order placed successfully");
    } else {
      showToast('error', result?.error?.message)
    }
  };

  return (
    <div className="flex min-w-[340px] flex-col flex-grow h-screen overflow-x-hidden">
      <div className="text-primary font-roboto font-semibold text-[24px] pb-4 ml-[24px] xl:mt-[24px] mt-[104px]">
        <h2 className="xl:hidden">Dashboard</h2>
      </div>
      <div className="overflow-y-auto mb-[48px] xl:mt-10">
        <div className=" bg-white font-inter flex flex-col justify-center items-center   lg:mx-[48px] mt-[32px] mx-[24px] border-[1px] border-medium-gray  rounded-lg py-8  md:py-10  max-w-full  md:max-w-[2200px]  px-[16px] lg:px-[48px] xl:px-[136px]">
          <div className=" w-full flex items-center flex-col">
            <div className="grid grid-cols-1 gap-x-6 w-full justify-center items-center">
              <div className="mb-10 ">
                <ProgressBar steps={steps} activeStep={3} completedStep={3} />{" "}
              </div>

              <div className="flex flex-col w-full items-center">
                <div className="flex   items-center  justify-center h-12">
                  <span className="text-level-2 sm:text-[24px] lg:text-[32px] xl:text-[32px] text-secondary font-roboto mb-[12px]  font-semibold   leading-[48px] ">
                    Payment Success !
                  </span>
                </div>

                <div className="w-full px-0 xs:px-2 sm:px-0 sm:w-[500px] md:w-[620px] lg:w-[580px] xl:w-[664px] h-auto rounded-[5px] font-inter text-[14px] sm:text-[18px] mt-0 sm:mt-3">
                  <div className="border-[1.5px] border-medium-gray items-center justify-center w-full sm:w-[500px] md:w-[620px] lg:w-[580px] xl:w-[664px] h-auto min-h-[292px] py-4 rounded-[5px] font-inter text-[12px] sm:text-[16px] lg:text-[18px] mt-3">
                    {!isFetchUserOrderById &&
                      <>
                        <div className="  ml-[84.69px] items-center  justify-cente">
                          <span className="text-level-3 xs:text-level-2  text-secondary font-inter flex  items-center  justify-center -ml-20 h-[37px] font-normal leading-[36.64px] mt-3">
                            Total Payment
                          </span>
                          <span className="text-level-3 sm:text-level-2 lg:text-[24px] xl:text-[24px] text-gray font-inter flex  items-center  justify-center -ml-20 h-[54px] font-semibold  leading-[53.29px] mt-3 ">
                            {currencyFormatter.format(currentOrder?.price || 0) || "$ 00.00"}
                          </span>
                          <span className="flex flex-col border-[1.67px] items-center  justify-center border-medium-gray mt-2  max-w-[1194.62px] mr-[84.69px] rounded-full"></span>
                        </div>
                        <div className=" h-full sm:h-[132px] mt-[22px]  max-w-full  w-auto mx-0 md:mx-[24px] lg:mx-[48px] xl:mx-[56px] ">
                          {[
                            { label: "Payment Receipt ID", value: currentOrder?.paymentDetils?.paypalPaymentId || "-" },
                            { label: "Payment Method", value: currentOrder?.paymentDetils?.method || "-" },
                            { label: "Payment Date", value: formatYYYY_MM_DD(currentOrder?.paymentDetils?.createdAt) || "-" },
                          ].map((item, idx) => (
                            <div
                              key={idx}
                              className="flex justify-between ml-6 mt-[11px] items-center mb-[10px] "
                            >
                              <span className="text-gray font-normal leading-[30px] sm:text-level-4 md:text-[16px] w-[48%] sm:w-[75%]  ">
                                {item.label}
                              </span>
                              <span className="text-secondary font-medium leading-[29.98px] sm:text-level-4 md:text-[16px] max-w-full md:max-w-[2200px]  mx-auto w-[58%] sm:w-[50%] md:w-[50%] lg:w-[50%]">
                                {item.value}
                              </span>
                            </div>
                          ))}
                        </div>
                      </>
                    }
                    {isFetchUserOrderById && (
                        <>
                          <div className="flex justify-center items-center w-full h-[100%] mt-[17%] md:mt-[13%]">
                            <ClipLoader
                              loading={isFetchUserOrderById}
                              speedMultiplier={0.5}
                              size={82}
                              color="#60a5fa"
                            /> 
                          </div>
                        </>
                      )
                    }
                  </div>

                  <div className="font-roboto flex justify-center flex-row gap-y-6 mt-6 w-full">
                    <CustomButton
                      text={
                        <>
                          <span className="sm:hidden">Next</span>{" "}
                          {/* Show "Proceed" only on small screens */}
                          <span className="hidden sm:inline">
                            Continue
                          </span>{" "}
                          {/* Show full text on larger screens */}
                        </>
                      }
                      iconDirection="right"
                      iconPosition="after"
                      width="80px sm:150px"
                      onClick={handleProceed}
                    />
                  </div>
                </div>
              </div>
            </div>{" "}
          </div>
        </div>{" "}
      </div>
    </div>
  );
};

export default SuccessPayment;
